import Vue from 'vue'
import VueRouter from "vue-router";
import Vuelidate from "vuelidate";
import AdminApp from "./containers/AdminApp";
import storePlugin from "./store/storePlugin";

// bootstrap
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import 'vue-datetime/dist/vue-datetime.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import "admin-lte/dist/css/adminlte.css";
import './styles/main.scss';
import './filters/index';
import './components/grid/styles.scss';
import '@fortawesome/fontawesome-free/css/all.css';
import 'alertifyjs/build/css/alertify.css';
import AdminRootApp from "./containers/AdminRootApp";
import AdminAuth from "./containers/AdminAuth";
import Login from "./modules/auth/containers/Login";
import VueI18n from 'vue-i18n';
import vueJsonEditor from 'vue-json-editor';
import axios from 'axios';
import {defaultLocale, languages} from "./i18n";
import {translationRouting} from "./modules/translations/routing";
import {playersRouting} from "./modules/players/routing";
import {administratorsRouting} from "./modules/administrator/routing";
import {transactionsRouting} from "./modules/transactions/routing";
import {dictionaryRouting} from "./modules/dictionary/routing";
import {configurationRouting} from "@/modules/configuration/routing";
import {cmsRouting} from "@/modules/cms/routing";
import {userSegmentRouting} from "@/modules/user-segment/routing";
import {userNotificationRouting} from "@/modules/user-notification/routing";
import {userCampaignRouting} from "@/modules/user-campaign/routing";
import {reportsRouting} from "@/modules/reports/routing";
import {statisticsRouting} from "@/modules/statistics/routing";
import {scheduledTournamentCalendarRouting} from "@/modules/scheduled-tournaments-calendar/routing";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(VueRouter);
Vue.use(VueI18n);

Vue.use(Vuelidate);
Vue.use(storePlugin);
Vue.use(vueJsonEditor);

const messages = Object.assign(languages);

const DashboardModule = () => import(/* webpackChunkName: "DashboardModule" */ './modules/dashboard/DashboardModule');
const WaitingRoomModule = () => import(/* webpackChunkName: "PlayerList" */ './modules/waiting-room/WaitingRoomModule');
const ActiveGameModule = () => import(/* webpackChunkName: "PlayerList" */ './modules/active-game/ActiveGameModule');
const GameResultModule = () => import(/* webpackChunkName: "PlayerList" */ './modules/game-result/GameResultModule');
const GameResultTournamentModule = () => import(/* webpackChunkName: "GameResultTournament */ './modules/game-result-tournament/GameResultTournamentModule');
const QuestionModule = () => import(/* webpackChunkName: "PlayerOverviewaa" */ './modules/question/QuestionModule');
const TournamentModule = () => import(/* webpackChunkName: "TournamentModule" */ './modules/tournaments/TournamentModule');
const ScheduledTournamentModule = () => import(/* webpackChunkName: "ScheduledTournamentModule" */ './modules/scheduled-tournaments/ScheduledTournamentModule');
const ActiveTournamentGameModule = () => import(/* webpackChunkName: "ActiveTournamentGameModule" */ './modules/active-tournament-game/ActiveTournamentGameModule');
const QuestionImportModule = () => import(/* webpackChunkName: "QuestionImportModule" */ './modules/question-import/QuestionImportModule');
const QuestionCategoryModule = () => import(/* webpackChunkName: "QuestionCategoryModule" */ './modules/question-category/QuestionCategoryModule');
const PlatformWalletModule = () => import(/* webpackChunkName: "PlatformWalletModule" */ './modules/platform-wallet/containers/PlatformWalletModule');
const ConfigurationManagementModule = () => import('./modules/configuration-management/ConfigurationManagementModule');
const ConfigurationLobbyFilterModule = () => import('./modules/configuration-lobby-filter-module/ConfigurationLobbyFilterModule');
const CoinPackagesGrid = () => import(/* webpackChunkName: "CoinPackagesGrid" */ './modules/coin-packages/containers/CoinPackagesGrid');
const QuizCoinPackagesGrid = () => import(/* webpackChunkName: "QuizCoinPackagesGrid" */ './modules/coin-packages/containers/QuizCoinPackagesGrid');
const ReportedErrorsGrid = () => import(/* webpackChunkName: "ReportedErrorsGrid" */ './modules/question/reported-errors/containers/ReportedErrors');
const BonusDefinitionModule = () => import(/* webpackChunkName: "BonusDefinition" */ './modules/bonus-definition/BonusDefinitionModule');
const PlayerExport = () => import(/* webpackChunkName: "PlayerExportModule" */ './modules/player-export/PlayerExportModule');
const MailBoxModule = () => import(/* webpackChunkName: "MailBoxModule" */ './modules/mail-box/MailBoxModule');
const WhiteLabelModule = () => import(/* webpackChunkName: "WhiteLabelModule" */ './modules/white-label/WhiteLabelModule');
const CrmDashboardModule = () => import(/* webpackChunkName: "CrmDashboardModule" */ './modules/crm-dashboard/CrmDashboardModule');
const InstantTournamentHistoryModule = () => import(/* webpackChunkName: "InstantTournamentHistoryModule" */ './modules/instant-tournament-history/InstantTournamentHistoryModule');

//Experimental Class component
const HelloClass = () => import('./components/HelloClass');

window.i18n = new VueI18n({
    locale: 'en',
    messages
});

export const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: 'en',
    silentTranslationWarn: true,
    messages
});

// Resolver before entering the page
// eslint-disable-next-line no-unused-vars
const walletResolver = async (to, from, next) => {
    axios.defaults.headers.common['X-AUTH-TOKEN'] = localStorage.getItem('apiKey');
    to.meta['wallets'] = await storePlugin.store.dispatch('root/getPlatformWallet');
    setTimeout(() => {
        next();
    }, 5000)
}

Vue.config.productionTip = false

export function setI18nLanguage(lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}

export function loadLanguageAsync(lang, first) {
    // If the same language
    if (i18n.locale === lang && !first) {
        return Promise.resolve(setI18nLanguage(lang))
    }

    return axios.get(`/i18n/${lang}.json`, {baseURL: ''}).then(response => {
        i18n.setLocaleMessage(lang, response.data)
        setI18nLanguage(lang)
    })
}


export class AdminVue {

    constructor() {
        this.initLibs();
        this.initWorkflowApp();
    }

    checkGuard(to, from, next) {
        const token = localStorage.getItem('apiKey');
        if (token) {
            next();
        } else {
            next('auth')
        }
    }

    initWorkflowApp() {
        const routes = [
            {
                path: '/auth',
                component: AdminAuth,
                children: [
                    {path: '/', name: 'login', component: Login},
                    {path: '/register', name: 'register', component: DashboardModule},
                ]
            },
            {
                path: '/',
                component: AdminApp,
                beforeEnter: this.checkGuard,
                children: [
                    {path: '/', name: 'dashboard', component: DashboardModule},
                    ...administratorsRouting,
                    ...playersRouting,
                    {path: '/fun-coins-packages', name: 'coins-package', component: CoinPackagesGrid},
                    {path: '/quiz-coins-packages', name: 'quiz-coins-package', component: QuizCoinPackagesGrid},
                    ...transactionsRouting,
                    ...dictionaryRouting,
                    ...configurationRouting,
                    {path: '/reported-errors', name: 'reported-errors', component: ReportedErrorsGrid},
                    {path: '/question', name: 'question-list', component: QuestionModule},
                    {path: '/question-import', name: 'question-list', component: QuestionImportModule},
                    {path: '/question-category', name: 'question-category-list', component: QuestionCategoryModule},
                    {path: '/waiting-room', name: 'waiting-room-list', component: WaitingRoomModule},
                    {path: '/active-game', name: 'active-game', component: ActiveGameModule},
                    {path: '/game-result', name: 'game-result-list', component: GameResultModule},
                    {path: '/game-result-tournament', name: 'game-result-tournament', component: GameResultTournamentModule},
                    {path: '/tournament', name: 'tournament', component: TournamentModule},
                    {path: '/active-tournament-game', name: 'active-tournament-game', component: ActiveTournamentGameModule},
                    {path: '/platform-wallet', name: 'platform-wallet', component: PlatformWalletModule},
                    {path: 'scheduled-tournament', name: 'scheduled-tournament', component: ScheduledTournamentModule},
                    {
                        path: '/configuration-management',
                        name: 'configuration-management',
                        component: ConfigurationManagementModule
                    },
                    {path: '/lobby-filter', name: 'lobby-filter', component: ConfigurationLobbyFilterModule},
                    {
                        path: '/hello-class',
                        name: 'hello-class',
                        component: HelloClass,
                        props: {msg: 'Counter Class Component!'}
                    },
                    translationRouting,
                    ...userSegmentRouting,
                    {path: '/bonus-definition', name: 'bonus-definition', component: BonusDefinitionModule},
                    ...cmsRouting,
                    {path: '/player-export', name: 'player-export', component: PlayerExport},
                    {path: '/mail-box', name: 'mail-box', component: MailBoxModule},
                    {path: '/white-label', name: 'white-label', component: WhiteLabelModule},
                    {path: '/crm-dashboard-module', name: 'crm-dashboard-module', component: CrmDashboardModule},
                    {path: '/instant-tournament-history-module', name: 'instant-tournament-history-module', component: InstantTournamentHistoryModule},
                    ...userNotificationRouting,
                    ...userCampaignRouting,
                    ...reportsRouting,
                    ...statisticsRouting,
                    ...scheduledTournamentCalendarRouting
                ]
            },
        ]

        const router = new VueRouter({
            routes,
            linkExactActiveClass: 'active'
        })

        // router.beforeEach((to, from, next) => {
        //     const lang = to.params.lang
        //     this.loadLanguageAsync(lang).then(() => next())
        // })

        loadLanguageAsync(defaultLocale, true);

        window.AdminVue = new Vue({
            i18n,
            router,
            render: h => h(AdminRootApp),
        }).$mount('#app')
    }

    initLibs() {
        Vue.directive('required-role', {
            bind: function (el, binding) {
                const roles = storePlugin.store.getters["root/userRoles"];
                let hasRole;
                const valueType = typeof binding.value;
                let requiredRoles;
                if (valueType === 'string') {
                    requiredRoles = [];
                    requiredRoles.push(binding.value);
                } else {
                    requiredRoles = this.binding.value;
                }
                requiredRoles.push('ROLE_SUPER_ADMIN');
                hasRole = roles.some(role => requiredRoles.includes(role));
                if (!hasRole) {
                    el.style.display = 'none';
                }
            }
        });

        Vue.directive('click-outside', {
            priority: 700,
            inserted: (el, binding, vnode) => {
                el.clickOutsideEvent = function (event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        // if clicked outside, call the provided method
                        vnode.context[binding.expression](event)
                    }
                }
                document.body.addEventListener('click', el.clickOutsideEvent)
                document.body.addEventListener('touchstart', el.clickOutsideEvent)
            },
            unbind: function (el) {

                document.body.removeEventListener('click', el.clickOutsideEvent)
                document.body.removeEventListener('touchstart', el.clickOutsideEvent)
            },
            stopProp(event) {
                event.stopPropagation()
            },
        });

        Vue.directive('remove-element-if-has-no-children', {
            bind: function (el, binding) {
                const displayChildren = Array.from(el.children).filter(el => {
                    return el.style.display !== 'none';
                });

                if(displayChildren.length === 0) {
                    setTimeout(() => {
                        document.getElementById(binding.value).style.display = 'none';
                    }, 50)
                }
            }
        });

        Vue.directive('required-roles', {
            bind: function (el, binding) {
                const roles = storePlugin.store.getters["root/userRoles"];
                let hasRole;
                let requiredRoles = binding.value;

                hasRole = roles.some(role => requiredRoles.includes(role));

                let isSuperAdmin = roles.includes("ROLE_SUPER_ADMIN");
                if (!hasRole && !isSuperAdmin) {
                    el.style.display = 'none';
                }
            }
        });
    }
}

new AdminVue();


